export default "__VITE_ASSET__BUWA_hd9__"